import React, { useState } from "react";
import { Link } from "react-router-dom";
import { GiRoundStar } from "react-icons/gi";
import "tailwindcss/tailwind.css";
const Jobcollections = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const jobs = [
    {
      id: 1,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 2,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 3,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 4,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 5,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 6,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 7,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
    {
      id: 8,
      title: "UI Developer",
      company: "First Filing",
      location: "Jaipur, Rajasthan, India (On-Site)",
      salary: "₹150K/Yr - ₹450K/Yr",
      time: "7 Hours Ago",
      logo: "https://placehold.co/50x50",
    },
  ];

  return (
    <div className="bg-[#F3F2EF] mt-16 ">
      <div className="container mx-auto">
        <div className="flex items-center justify-between h-12 bg-white my-4 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-row items-center space-x-2 ">
            <GiRoundStar className="text-[30px] text-[#56687A] bg-[#CCE0F5] h-7 w-7 p-1 rounded-full border border-[1px] border-[#217BD5]" />
            <span className="text-sm">For You</span>
          </div>
          <div className="flex items-center space-x-2">
            <img
              src="/Images/jobcollections/social-impact 2.png"
              alt="Social Impact icon"
              className="mb-1"
            />
            <span className="text-sm">Social Impact</span>
          </div>
          <div className="flex  items-center space-x-2">
            <img
              src="/Images/jobcollections/ecology 2.png"
              alt="Sustainability icon"
              className="mb-1"
            />
            <span className="text-sm">Sustainability</span>
          </div>
          <div className="flex  items-center space-x-2">
            <img
              src="/Images/jobcollections/shapes 2.png"
              alt="DEI icon"
              className="mb-1"
            />
            <span className="text-sm">DEI</span>
          </div>
          <div className="flex  items-center space-x-2">
            <img
              src="/Images/jobcollections/career 2.png"
              alt="Career Growth icon"
              className="mb-1"
            />
            <span className="text-sm">Career Growth</span>
          </div>
          <div className="flex  items-center space-x-2">
            <img
              src="/Images/jobcollections/remote-access 1.png"
              alt="Remote icon"
              className="mb-1"
            />
            <span className="text-sm">Remote</span>
          </div>
          <div className="flex  items-center space-x-2">
            <img
              src="/Images/jobcollections/balance 1.png"
              alt="Work Life Balance icon"
              className="mb-1"
            />
            <span className="text-sm">Work Life Balance</span>
          </div>
        </div>
      </div>

      <div className="bg-[#F3F2EF] mt-4 ">
        <div className="container mx-auto">
          <div classname="flex flex-col lg:flex-row">
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-1/2 lg:w-1/2 py-4 px-4 sm:px-6 lg:px-8 h-screen overflow-y-auto ">
                <div className="flex  justify-between">
                  <div class="flex flex-col items-start px-8 mb-4">
                    <h2 class="text-lg font-semibold">Top Job Picks For You</h2>
                    <p className="text-sm text-gray-600 w-96">
                      Based on your profile, preferences, and activity like
                      Applies, Searches, and Saves
                    </p>
                    <div class="flex items-center">
                      <span class="text-sm text-gray-500 mr-2">
                        955 Results
                      </span>
                    </div>
                  </div>
                  <div className="mt-2">
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                {jobs.map((job) => (
                  <div
                    key={job.id}
                    class="flex justify-between w-full p-4 border-b bg-white "
                  >
                    <div class="flex items-start space-x-4">
                      <img
                        src={job.logo}
                        alt="Company Logo"
                        class="w-12 h-12 mr-4"
                      />
                      <div>
                        <h3 class="text-lg font-semibold">{job.title}</h3>
                        <p class="text-sm text-gray-500">{job.company}</p>
                        <p class="text-sm text-gray-500">{job.location}</p>
                        <p class="text-sm text-gray-500">{job.salary}</p>
                        <p class="text-sm text-blue-500">{job.time}</p>
                      </div>
                    </div>
                    <div className="flex flex-col justify-self-end">
                      <button class=" text-gray-500 hover:text-gray-700">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div class="w-full md:w-1/2 lg:w-1/2 bg-[#F1F4F880] py-4 px-4 sm:px-6 lg:px-8 h-screen overflow-y-auto">
                <div class=" mb-4">
                  <div className="flex flex-col mb-4">
                    <div className="flex justify-between">
                      <div className="flex items-center space-x-2">
                        <img
                          src="https://placehold.co/40x40"
                          alt="Company Logo"
                          className="w-10 h-10 mr-2"
                        />

                        <h1 className="text-lg ">Comfygen Private Limited</h1>
                      </div>
                      <div flex flex-col items-start>
                        <button
                          class="text-gray-500 hover:text-gray-700 "
                          onClick={openModal}
                        >
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        {isModalOpen && (
                          <div class="relative">
                            <div class="absolute flex justify-between right-0 mt-1 w-48 bg-white border rounded shadow-lg">
                              <div>
                                <Link
                                  to="#"
                                  class="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                                >
                                  Send Feedback
                                </Link>
                                <Link
                                  to="#"
                                  class="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                                >
                                  Report This Job
                                </Link>
                              </div>
                              <div className="flex flex-col mr-4 py-2">
                                <button
                                  onClick={closeModal}
                                  className="text-gray-500 hover:text-gray-700"
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-4">
                      <h2 className="text-xl text-black font-bold">
                        UI Developer
                      </h2>
                      <p className="text-sm text-gray-500 mb-2">First Filing</p>
                      <p className="text-sm text-gray-500 mb-2">
                        Jaipur, Rajasthan, India,{" "}
                        <span className="text-blue-500">7 Hours Ago</span> · 11
                        People Clicked Apply
                      </p>
                      <div className="flex items-center text-sm text-gray-500 mb-2">
                        <i className="fas fa-briefcase mr-2"></i>
                        <span>
                          ₹150K/Yr - ₹450K/Yr · On-Site · Full-Time · Associate
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4">
                  <p class="text-sm text-gray-500">
                    Curious Where You Stand? See How You Compare To 11 Others
                    Who Clicked Apply. Try Premium For ₹0
                  </p>
                </div>
                <div class="flex mb-4 space-x-4">
                  <button className="bg-blue-500 text-white w-24 px-4 py-1 rounded-full">
                    Apply
                  </button>
                  <button className="border border-blue-500 text-blue-500 w-24 px-4 py-1 rounded-full">
                    Save
                  </button>
                </div>
                <div className="mt-8">
                  <h4 class="text-lg font-semibold mb-2">About The Job</h4>
                  <p class="text-sm text-gray-700 mb-2">
                    <strong>Skills:</strong>
                  </p>
                  <p class="text-sm text-gray-900 mb-2">
                    HTML, CSS, JavaScript, React, Angular, Vue.Js, Responsive
                    Design, UI/UX Design,
                  </p>
                  <p class="text-sm text-gray-700 mb-2">
                    We Are Looking For A Talented UI Developer Who Is Proficient
                    In JavaScript, CSS, And HTML To Join Our Team. This Role
                    Requires A Strong Eye For Design And A Deep Understanding Of
                    Front-End Development. You Will Work Closely With Our
                    Designers And Back-End Developers To Build Visually
                    Appealing, Responsive, And Interactive Interfaces.
                  </p>
                  <p class="text-sm text-gray-900 mt-8 mb-2">
                    <strong>Responsibilities:</strong>
                  </p>
                  <ul class="list-disc list-inside text-sm text-gray-700">
                    <li>
                      Develop And Maintain The Front-End Of Web Applications.
                    </li>
                    <li>
                      Translate UI/UX Design Wireframes Into High-Quality Code.
                    </li>
                    <li>Ensure The Technical Feasibility Of UI/UX Designs.</li>
                    <li>
                      Optimize Applications For Maximum Speed And Scalability.
                    </li>
                    <li>
                      Collaborate With Other Team Members And Stakeholders To
                      Improve Usability And Functionality.
                    </li>
                    <li>
                      Ensure Cross-Browser Compatibility And Responsive Design.
                    </li>
                  </ul>
                  <p class="text-sm text-gray-900 mt-8 mb-2">
                    <strong>Requirements:</strong>
                  </p>
                  <ul class="list-disc list-inside text-sm text-gray-700">
                    <li>
                      Develop And Maintain The Front-End Of Web Applications.
                    </li>
                    <li>
                      Translate UI/UX Design Wireframes Into High-Quality Code.
                    </li>
                    <li>Ensure The Technical Feasibility Of UI/UX Designs.</li>
                    <li>
                      Optimize Applications For Maximum Speed And Scalability.
                    </li>
                    <li>
                      Collaborate With Other Team Members And Stakeholders To
                      Improve Usability And Functionality.
                    </li>
                    <li>
                      Ensure Cross-Browser Compatibility And Responsive Design.
                    </li>
                  </ul>
                </div>
                <div className="bg-blue-100 p-4 mt-6 rounded-lg shadow-md max-w-md">
                  <div className="bg-blue-500 text-white text-xs font-semibold px-2 py-1 rounded-full inline-block mb-2">
                    Employer-Provided
                  </div>
                  <h2 className="text-lg font-semibold mb-1">
                    Pay Range In Jaipur
                  </h2>
                  <p className="text-gray-700 text-sm mb-2">
                    Exact Compensation May Vary Based On Skills, Experience, And
                    Location.
                  </p>
                  <p className="text-gray-700 text-sm font-semibold">
                    Base Salary
                  </p>
                  <p className="text-gray-900 text-lg font-bold">
                    ₹20,000/Yr - ₹30,000/Yr
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobcollections;
